import { j as t } from "./atoms-v218.js";
import { forwardRef as P } from "react";
import { PictureSkeleton as h } from "./atoms-v2728.js";
import { Picture as $, Img as g } from "./atoms-v2729.js";
import { useBreakpoints as S } from "./atoms-v251.js";
const b = P(
  ({
    alt: o = "",
    ariaHidden: a = !1,
    aspectRatio: i = "2/1",
    className: s,
    defaultSource: m,
    height: c,
    id: n,
    isSkeleton: p = !1,
    loading: f = "eager",
    onLoad: u,
    sources: e,
    width: d
  }, j) => {
    const { queries: x } = S();
    if (p)
      return /* @__PURE__ */ t.jsx(h, { aspectRatio: i });
    const l = e && Object.values(e).some((r) => r && r.length > 0);
    return /* @__PURE__ */ t.jsxs(
      $,
      {
        $aspectRatio: i,
        "aria-hidden": a,
        className: s,
        "data-testid": "picture",
        id: n,
        ref: j,
        children: [
          l && Object.keys(e).map((r) => /* @__PURE__ */ t.jsx(
            "source",
            {
              media: x[r],
              srcSet: `${e[r]}`
            },
            r
          )),
          /* @__PURE__ */ t.jsx(
            g,
            {
              $aspectRatio: i,
              alt: o,
              className: s,
              height: c,
              loading: f,
              onLoad: u,
              src: m,
              width: d
            }
          )
        ]
      }
    );
  }
);
b.displayName = "Picture";
export {
  b as Picture
};
